import type { MarketplaceStats } from "@/lib/marketplaceStats";

export interface TrackerStatsBootstrap {
  gamesTracked: number;
  shopsTracked: number;
  priceChangesThisWeek: number;
  latestChangeAt: string | null;
  totalGames: number;
}

interface HomeBootstrap {
  trackerStats?: TrackerStatsBootstrap;
  marketplaceStats?: MarketplaceStats;
}

interface BootstrapPayload {
  home?: HomeBootstrap;
}

function readBootstrap(): BootstrapPayload {
  if (typeof document === "undefined") return {};
  const node = document.getElementById("__BOOTSTRAP__");
  if (!node?.textContent) return {};
  try {
    return JSON.parse(node.textContent) as BootstrapPayload;
  } catch {
    return {};
  }
}

const bootstrap = readBootstrap();

export function getBootstrapHomeStats(): MarketplaceStats | undefined {
  return bootstrap.home?.marketplaceStats;
}

export function getBootstrapTrackerStats(): TrackerStatsBootstrap | undefined {
  return bootstrap.home?.trackerStats;
}
